<template>
  <div class="layout-v2">
    <TheSideBar style="width: 260px; min-width: 260px;"/>
    <div style="width: calc(100vw - 260px)">
      <nav-bar class="shadow-sm" />
      <div class="component_view">
        <router-view :key="key" />
      </div>
    </div>
  </div>
</template>

<script>
import vertical from './vertical.vue'
import TheSideBar from './the-sidebar.vue'
import TheTopBar from './the-topbar.vue'
import NavBar from './nav-bar.vue'
export default {
  components: { vertical, TheSideBar, NavBar, TheTopBar},
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style>
.layout-v2 {
  display: flex;
}
.component_view {
  padding: 20px;
  height: calc(100vh - 63px);
  overflow-y: auto;
}
</style>